import {useEffect, useState} from 'react';
import './testimony.scss';
import {useTranslation} from "react-i18next";
import {createReview, getReviews} from "../../../api/api";
import { Review } from "../../../interfaces/interfaces"
import {Modal} from "../../../components/User_Side/modal/Modal";

const Testimony = ({ props }: {
    props: {
       modal: boolean;
       setModal: (modal: boolean) => void;
       submitted: boolean;
       setSubmitted: (submitted: boolean) => void;}
}) => {
    const [reviews, setReviews] = useState<Review[]>([]);
    const {t} = useTranslation()

    const load = () => getReviews()
        .then((data: Review[]) => setReviews(data.slice(0, 10)))
        .catch(console.error);

    const Stars = ({ rating }: { rating: number }) => (
        <div style={{ display: 'flex', gap: 2 }}>
            {[1, 2, 3, 4, 5].map(star => (
                <span key={star} style={{ color: star <= rating ? '#78218a' : '#444', fontSize: '1rem' }}>
                ★
            </span>
            ))}
        </div>
    );

    useEffect(() => { load(); }, []);

    return (
        <div className={"Testimony"}>
            <div className={"textes-wrapper"}>
                <div className={"section"}>
                    <h3 className={"section-title"}>{t("testimony.title")}</h3>
                    <button className="btn" onClick={() => props.setModal(true)}>
                        {t("testimony.leave-review")}
                    </button>
                    {props.modal && (
                        <Modal
                            message={t("testimony.share-experience-mariposa")}
                            fields={[
                                { name: 'customerName', label: `${t("testimony.your-name")}`, placeholder: `${t("testimony.your-name")}`},
                                { name: 'rating', label: `${t("testimony.note")}`, type: 'rating' },
                                { name: 'title', label: `${t("testimony.rating-title")}`, placeholder: 'Titre de votre avis' },
                                { name: 'content', label: `${t("testimony.your-review")}`, type: 'textarea', placeholder: `${t("testimony.share-experience")}`},
                            ]}
                            confirmLabel={t("testimony.send")}
                            cancelLabel={t("testimony.cancel")}
                            onCancel={() => props.setModal(false)}
                            submitted={props.submitted}
                            confirmationText={t("testimony.thank-you")}
                            onConfirm={async (data) => {
                                if (!data?.customerName || !data?.title || !data?.content || !data?.rating) return;
                                try {
                                    await createReview({
                                        customerName: data.customerName,
                                        title: data.title,
                                        content: data.content,
                                        rating: parseInt(data?.rating || '5')
                                    });
                                    props.setModal(false);
                                    props.setSubmitted(true);
                                    setTimeout(() => props.setSubmitted(false), 4000);
                                    load();
                                } catch (e) { console.error(e); }
                            }}
                        />
                    )}
                    <div className={"section-paragraph"}>
                        <div className={"testimony-section"}>
                            {reviews.map((review: Review) => (
                                <div key={review.id} className="testimony-card">
                                    <p className="testimony-author">{review.customerName}</p>
                                    <h4 className="testimony-title">{review.title}</h4>
                                    <Stars rating={review.rating} />
                                    <p className="testimony-content">{review.content}</p>
                                    {review.response && (
                                        <div className="testimony-response">
                                            <p className="testimony-response-label">{t("testimony.mariposa-reply")} :</p>
                                            <p className="testimony-response-content">{review.response}</p>
                                        </div>
                                    )}
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimony;
